<template>
  <div>
    <v-row
      class="mt-5"
    >
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="data"
            :chart-value-keys="[ { key: getVariableName('UXPCSTD'), type: 'bar', label: $t('card_title.total_distance') }, { key: getVariableName('UXPCSMYPM'), label: 'm/min' } ]"
            x-value="last_name"
            y-value-prefix="latest_stats."
            :yaxis="[ { title: { text: $t('card_title.total_distance') }}, { title: { text: 'm/min' }, opposite: true } ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: data.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.total_distance_and_m_min') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="data"
            :chart-value-keys="[ { key: getVariableName('CALETLDLHSR'), label: $t('chart_legends.hsr_distance'), type: 'bar' }, { key: getVariableName('UXPCSEEF'), label: $t('chart_legends.of_explosive_efforts') } ]"
            x-value="last_name"
            y-value-prefix="latest_stats."
            :yaxis="[ { title: { text: $t('chart_legends.hsr_distance') }}, { title: { text: $t('chart_legends.explosive_efforts') }, opposite: true } ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: data.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#FF4560', '#775DD0' ]"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.high_speed_running_and_explosive_efforts') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
    <v-row
      class="mt-3"
    >
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="data"
            :chart-value-keys="[ { key: getVariableName('UXVOL'), type: 'bar', label: $t('gps_variables.volume') },
                                 { key: getVariableName('UXINTS'), label: $t('gps_variables.intensity') } ]"
            x-value="last_name"
            y-value-prefix="latest_stats."
            :yaxis="[ { title: { text: $t('gps_variables.volume') }}, { title: { text: $t('gps_variables.intensity') }, opposite: true } ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: data.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#FEB019', '#008FFB' ]"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.volume_and_intensity') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="data"
            :chart-value-keys="[ { key: getVariableName('CALETLDLSP'), type: 'bar', label: $t('card_title.sprint_distance') }, { key: getVariableName('CACGCSMXV'), label: $t('chart_legends.maximum_velocity_km_h') } ]"
            x-value="last_name"
            y-value-prefix="latest_stats."
            :yaxis="[ { title: { text: $t('card_title.sprint_distance') }}, { title: { text: $t('chart_legends.velocity') }, opposite: true } ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: data.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#c42b59', '#ad6843' ]"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.sprint_distance_and_maximum_velocity') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
    <v-row class="mt-3">
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="data"
            :chart-value-keys="[ { key: getVariableName('CAPGCSDCB13EG2'), type: 'bar', label: $t('chart_legends.deceleration_less_-4') },
                                 { key: getVariableName('UXDCB13'), type: 'bar', label: $t('chart_legends.deceleration_less_-3') },
                                 { key: getVariableName('UXDCB14'), type: 'bar', label: $t('chart_legends.deceleration_less_-2') },
                                 { key: getVariableName('UXACB58'), type: 'bar', label: $t('chart_legends.accelerations_more_2') },
                                 { key: getVariableName('UXACB68'), type: 'bar', label: $t('chart_legends.accelerations_more_3') },
                                 { key: getVariableName('CAPGCSACB13EG2'), type: 'bar', label: $t('chart_legends.accelerations_more_4') } ]"
            x-value="last_name"
            y-value-prefix="latest_stats."
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: data.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="[ '#ff0000', '#ff6666', '#ff9999', '#1affb2', '#00e396', '#00b377']"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.accelerations_and_decelerations') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart'

export default {
  name: 'PerformanceWeeklyGraphs',
  components: { LineChart },
  props: {
    data: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'total'
    }
  },
  methods: {
    getVariableName(variable) {
      let insert = ''

      if (this.type === 'games') insert = '_G'
      else if (this.type === 'games60') insert = '_G_60'

      return variable + insert + '_7'
    }
  }
}
</script>

<style scoped>

</style>
